// theme.service.ts
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export type ModoTema = 'claro' | 'oscuro' | 'sistema';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly STORAGE_KEY = 'modo-tema';
  private isBrowser: boolean;
  private mql?: MediaQueryList;
  private listener?: (e: MediaQueryListEvent) => void;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      // Configuramos el listener de cambios en el modo del sistema
      this.mql = window.matchMedia('(prefers-color-scheme: dark)');
      this.listener = () => {
        if (this.getMode() === 'sistema') {
          this.applyTheme('sistema');
        }
      };

      if (this.mql.addEventListener) {
        this.mql.addEventListener('change', this.listener);
      } else {
        this.mql.addListener(this.listener);
      }
    }
  }

  /** Debe llamarse desde e.g. AppComponent.ngOnInit() */
  initTheme(): void {
    if (!this.isBrowser) {
      return;
    }
    this.applyTheme(this.getMode());
  }

  getMode(): ModoTema {
    if (!this.isBrowser) {
      // En servidor siempre devolvemos 'sistema' para no romper la renderización
      return 'sistema';
    }
    return (localStorage.getItem(this.STORAGE_KEY) as ModoTema) || 'sistema';
  }

  setMode(mode: ModoTema): void {
    if (!this.isBrowser) {
      return;
    }
    localStorage.setItem(this.STORAGE_KEY, mode);
    this.applyTheme(mode);
  }

  private applyTheme(mode: ModoTema): void {
    if (!this.isBrowser) {
      return;
    }
    const isDark =
      mode === 'oscuro' ||
      (mode === 'sistema' && this.mql?.matches === true);

    document.documentElement.classList.toggle('my-app-dark', isDark);
  }
}
